__turbopack_context__.v({
  "closeButton": "selectedPeriodTag-module-scss-module__3AfosG__closeButton",
  "container": "selectedPeriodTag-module-scss-module__3AfosG__container",
  "icon": "selectedPeriodTag-module-scss-module__3AfosG__icon",
  "periodName": "selectedPeriodTag-module-scss-module__3AfosG__periodName",
});
